export { SharedAuthPage } from './SharedAuthPage.js';
export { SharedAuthProvider, useSharedAuth } from '../../lib/auth/SharedAuthProvider.js';
export { getAuthConfig, defaultAuthConfig, appConfigs } from '../../lib/auth/auth-config.js';
export type { AuthConfig } from '../../lib/auth/auth-config.js';
